import React, { createContext, PropsWithChildren, useEffect } from 'react';
import { usePowerBIEmbedConfig } from '../../hooks/usePowerBiEmbedConfig';
import { PowerBiReport } from '../../interfaces/PowerBiReport';
import { usePendoPortal } from '../../hooks/usePendoPortal';

export interface PowerBiContextInterface {
  appName?: string;
  config?: PowerBiReport;
  hasAccess?: boolean;
  loading?: boolean;
  track?: (event: string, metadata?: Record<string, unknown>) => void;
}

export const PowerBiContext = createContext<PowerBiContextInterface>({});

interface PowerBiProviderProps extends PropsWithChildren {
  appName: string;
  pendoApiKey: string | undefined;
}

export function PowerBiProvider({
  children,
  appName,
  pendoApiKey,
}: Readonly<PowerBiProviderProps>) {
  const { config, hasAccess, loading } = usePowerBIEmbedConfig(appName);
  const { track } = usePendoPortal(pendoApiKey);

  // eslint-disable-next-line no-console
  console.log('Track', track);

  useEffect(() => {
    if (hasAccess) track('report_opened', { reportName: appName });
  }, [appName, hasAccess, track]);

  return (
    <PowerBiContext.Provider
      value={{ appName, config, hasAccess, loading, track }}
    >
      {children}
    </PowerBiContext.Provider>
  );
}
